import { BubbleBody, type WaRendererProps } from './primitives';

/** Plain text, and the default body for every kind that has no visual of its
 *  own. `view.body` is guaranteed non-empty by the normalizer, so this can
 *  never render an invisible bubble. */
export function TextMessage({ view }: WaRendererProps) {
  return <BubbleBody>{view.body ?? view.fallbackLabel}</BubbleBody>;
}
